import React from 'react'
import Nav from 'react-bootstrap-five/Nav'

type Props = {
  children: React.ReactNode
  className?: string
  // Accessible name for the underlying tablist. `role="tablist"` lands on
  // the inner Nav (via Tab.Container), so the name belongs there — without
  // it a screen reader announces an unnamed tablist (WCAG 1.3.1 / 4.1.2).
  // Optional to stay back-compatible with existing single-purpose callers.
  ariaLabel?: string
  // Compact spacing for narrow containers (e.g. the 340px-wide feedback
  // inbox rail, `scenes/FeedbackInbox/RightRail/index.tsx`) — the default
  // styling (Bootstrap's `.container` gutters, plus TabItem's full-width
  // `px-m` padding and uppercase SmallCaps label) was built for full-width
  // pages and overflows a rail this narrow. Compact drops the `.container`
  // gutters and applies `.nav-tabs-compact` (`stylesheets/_tabs.scss`),
  // which pairs with TabItem's own `compact` prop for smaller padding and a
  // non-uppercase label. Default (false) leaves every other TabNav consumer
  // pixel-identical.
  compact?: boolean
}

const TabNav = ({
  children,
  className = '',
  ariaLabel,
  compact = false,
}: Props) => {
  const navClassName = compact
    ? `nav-tabs border-none nav-tabs-compact ${className}`
    : `container nav-tabs border-none ${className}`

  return (
    <div className="border-bottom-1 grey-20-border">
      <Nav className={navClassName} aria-label={ariaLabel}>
        {children}
      </Nav>
    </div>
  )
}

export default TabNav
